document.addEventListener("DOMContentLoaded", function() {
  // Existing accordion functionality
  const accordionItems = document.querySelectorAll('.accordion-title');
  
  accordionItems.forEach(item => {
    item.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.accordion-icon');
      
      if (content.style.display === "block") {
        content.style.display = "none";
        icon.textContent = "+";
      } else {
        content.style.display = "block";
        icon.textContent = "-";
      }
    });
  });

  // Define toggleDescription in the global scope
  window.toggleDescription = function() {
    const description = document.getElementById('description-text');
    const button = document.getElementById('read-more-btn');

    if (description.classList.contains('expanded')) {
      description.classList.remove('expanded');
      button.innerText = 'Read More';
    } else {
      description.classList.add('expanded');
      button.innerText = 'Read Less';
    }
  };

  // Attach the event listener using JavaScript
  const toggleDescriptionButton = document.getElementById('read-more-btn');
  if (toggleDescriptionButton) {
    toggleDescriptionButton.addEventListener('click', window.toggleDescription);
  }

  // Existing load more products functionality
  const loadMoreBtn = document.getElementById('load-more-btn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', loadMoreProducts);
  }

  // Function to update the main product image based on the selected variant
  function updateVariantImage(variantId) {
    var variantImage = document.querySelector(`img[data-variant-id="${variantId}"]`);
    if (variantImage) {
      // Update the main product image
      var mainImage = document.querySelector('.product-main-image');
      mainImage.src = variantImage.src;

      // Ensure the gallery updates correctly
      updateImageGallery(variantImage);
    }
  }

  // Function to adjust the gallery view to the selected image
  function updateImageGallery(selectedImage) {
    var gallery = document.querySelector('.product-image-gallery');
    if (gallery) {
      var images = gallery.querySelectorAll('img');
      var selectedIndex = Array.from(images).indexOf(selectedImage);

      // Logic to adjust the gallery view to the selected image
      if (selectedIndex > -1) {
        gallery.scrollTo({
          left: selectedIndex * gallery.clientWidth,
          behavior: 'smooth'
        });
      }
    }
  }

  // Add event listeners to variant selectors
  document.querySelectorAll('.variant-selector').forEach(function(selector) {
    selector.addEventListener('change', function(event) {
      var selectedVariantId = event.target.value;
      updateVariantImage(selectedVariantId);
    });
  });

  // Ensure main image loads first on mobile
  function ensureMainImageFirst() {
    var mainImage = document.querySelector('.product-main-image');
    if (mainImage) {
      var gallery = document.querySelector('.product-image-gallery');
      if (gallery) {
        var firstImage = gallery.querySelector('img');
        if (firstImage && firstImage.src !== mainImage.src) {
          mainImage.src = firstImage.src;
        }
      }
    }
  }

  // Call the function to ensure main image loads first on page load
  ensureMainImageFirst();

  // Fix for mobile view: Ensure the main image loads first
  window.addEventListener('load', ensureMainImageFirst);

  // New code to remove <br> tags within the specified sections
  const sections = document.querySelectorAll('.product-accordion .accordion-content.whats-included, .product-accordion .accordion-content.disclaimer');

  sections.forEach(section => {
    section.querySelectorAll('br').forEach(br => {
      console.log('Removing <br> tag'); // Debugging log
      br.remove();
    });
  });
});

// Existing loadMoreProducts function
let productsLoaded = 27;

function loadMoreProducts() {
  const loadMoreBtn = document.getElementById('load-more-btn');
  loadMoreBtn.disabled = true; // Disable the button to prevent multiple clicks
  loadMoreBtn.innerText = 'Loading...';

  fetch(`${window.location.pathname}?view=load-more&page=${Math.ceil(productsLoaded / 27) + 1}`)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelector('#product-grid').innerHTML;

      document.querySelector('#product-grid').innerHTML += newProducts;
      productsLoaded += 27;

      const totalProducts = parseInt(document.getElementById('collection-root').getAttribute('data-collection-count'));

      if (productsLoaded >= totalProducts) {
        loadMoreBtn.style.display = 'none';
      } else {
        loadMoreBtn.disabled = false;
        loadMoreBtn.innerText = 'Load More';
      }
    })
    .catch(error => {
      console.error('Error loading more products:', error);
      loadMoreBtn.disabled = false;
      loadMoreBtn.innerText = 'Load More';
    });
}



